import React from 'react';
import './style.css';
import {Col, Row} from "antd";

export const AppSiteWrapper = (props: any) => {
    return <div id={'main-wrapper'} style={props.style}>
        {props.children}
    </div>
};


export const AppContentWrapper = (props: any) => {
    return <Row justify={'center'} style={props.style}>
        <Col flex={1} className={'contentPadding'}>
            {props.children}
        </Col>
    </Row>;
};
